<template>
  <div>
    <list row-key="OtherPayId" ref="list" unit="其他应付单" light-row @row-select="x => $emit('change', x)" :page="page"
      :query-params="params" :show-checkbox="showCheckbox" :show-query="showQuery" :get-data-func="api.list"
      :getColumn="tableColumns" :getParams="tableParams" :trendColumn="trendColumn" :trendParams="trendParams"
      v-if="trendShow">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <!-- <template slot="query">
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="业务类型">
          <business-select
            v-model="params.BusinessTypeId"
            :params="{Kind:'应付',SourceType:'其他应付单'}"
          />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="往来单位">
          <select-input
            placeholder="请选择单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
      </template> -->
      <template slot="table">
        <!-- <el-table-column prop="DocNo" label="单据编号" min-width="150" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="100">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.DocDate) }}</template>
        </el-table-column>
        <el-table-column prop="BusinessType" label="业务类型" min-width="100" />
        <el-table-column prop="LastDate" label="付款到期日" min-width="100">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.LastDate) }}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="往来单位" min-width="130" show-overflow-tooltip />
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="ClerkName" label="经办人" min-width="100" />
        <el-table-column prop="Status" label="单据状态" width="100px">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-if="row.Status==1">未生效</span>
            <span v-if="row.Status==2">已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="140" show-overflow-tooltip /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- 后面补充 -->
    <!-- <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" /> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/ocost/list.json";
import tableParam from "@/data/finance/dealings/ocost/query.json";
// import businessSelect from "@/components/basedoc/business/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    // businessSelect,
     tradeunitDialog 
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/rp/otherPay").default,
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      trendColumn: tableColumn.Data,
      trendParams: tableParam.Data,
      tableColumns: tableColumn.Data,
      tableParams: tableParam.Data,
      trendShow: true,
      params: {
        TradeUnitId: null,
        TradeUnitName: "",
        BusinessTypeId: null,
        DocNo: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
      isMB: this.$store.state.isMB,
    };
  },

  methods: {
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);

            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );

              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);

            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.FullName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>